import { useId } from 'react';

import styles from './animations.module.css';

interface ConnectionLostProps {
  width?: string;
  height?: string;
  className?: string;
}

const ConnectionLost = ({
  width = '150px',
  height = 'auto',
  className = '',
}: ConnectionLostProps) => {
  const clipId = `earth-clip-${useId()}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="8 32 84 36"
      fill="none"
      shapeRendering="geometricPrecision"
      style={{ width, height }}
      className={className}
    >
      <g className={styles.animateDrift}>
        {/* Left node: earth & orbit */}
        <circle
          className={styles.spinLeft}
          cx="26"
          cy="50"
          r="16"
          stroke="#38bdf8"
          strokeWidth="1.5"
          strokeDasharray="4 3"
          opacity="0.5"
        />
        <g>
          <circle cx="26" cy="50" r="10" fill="#0284c7" />
          <clipPath id={clipId}>
            <circle cx="26" cy="50" r="10" />
          </clipPath>
          <g clipPath={`url(#${clipId})`}>
            <path
              d="M 18 46 Q 22 40 28 44 Q 32 46 35 50 Q 28 54 22 52 Z"
              fill="#22c55e"
            />
            <path
              d="M 23 56 Q 27 58 31 55 Q 34 52 35 58 Q 28 62 21 58 Z"
              fill="#22c55e"
            />
          </g>
          <circle
            cx="26"
            cy="50"
            r="10"
            stroke="#38bdf8"
            strokeWidth="0.75"
            opacity="0.5"
          />
        </g>

        {/* Right node: moon & orbit */}
        <circle
          className={styles.spinRight}
          cx="74"
          cy="50"
          r="15"
          stroke="#94a3b8"
          strokeWidth="1.5"
          strokeDasharray="4 4"
          opacity="0.4"
        />
        <g>
          <circle cx="74" cy="50" r="7" fill="#cbd5e1" />
          <circle cx="72" cy="47" r="1.2" fill="#94a3b8" opacity="0.6" />
          <circle cx="76" cy="52" r="1" fill="#94a3b8" opacity="0.6" />
          <circle cx="76" cy="46" r="0.6" fill="#94a3b8" opacity="0.6" />
        </g>

        {/* Broken connection backbone */}
        <path
          d="M 39 50 L 44 50"
          stroke="#64748b"
          strokeWidth="3"
          strokeLinecap="round"
          opacity="0.7"
        />
        <path
          d="M 56 50 L 64 50"
          stroke="#64748b"
          strokeWidth="3"
          strokeLinecap="round"
          opacity="0.7"
        />

        {/* Moving data packet */}
        <circle
          className={styles.dataDot}
          cx="0"
          cy="50"
          r="2"
          fill="#38bdf8"
        />

        {/* Error cross */}
        <g className={styles.errorFlare}>
          <path
            d="M 46 46 L 54 54 M 54 46 L 46 54"
            stroke="#ef4444"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default ConnectionLost;
